import axios from 'axios';

// 直接根据环境变量设置API地址
const getApiBaseUrl = () => {
  // 使用REACT_APP_ENV环境变量
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
  
  if (env === 'production') {
    return 'https://api.wevoov.com/api/cus/union/user';
  } else {
    return 'http://47.117.130.86:9090/api/cus/union/user';
  }
};

// 创建axios实例
const api = axios.create({
  // 根据环境动态配置API地址
  baseURL: getApiBaseUrl(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  // 允许跨域请求携带凭证
  withCredentials: false,
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 添加请求头
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    // 如果是开发环境，添加CORS相关头
    if (process.env.NODE_ENV === 'development') {
      config.headers['Access-Control-Allow-Origin'] = '*';
      config.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS';
      config.headers['Access-Control-Allow-Headers'] = 'Content-Type, Authorization';
    }

    console.log('API Request:', config.method?.toUpperCase(), config.url, config.data);
    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.status, response.data);
    return response;
  },
  (error) => {
    console.error('Response Error:', error);

    // 处理跨域错误
    if (error.code === 'ERR_NETWORK') {
      console.error('Network Error - Possible CORS issue');
      error.message = 'Network Error - Please check CORS configuration';
    }

    // 处理超时错误
    if (error.code === 'ECONNABORTED') {
      error.message = 'Request timeout';
    }

    // 处理HTTP错误
    if (error.response) {
      const { status, data } = error.response;
      console.error(`HTTP ${status}:`, data);

      switch (status) {
        case 401:
          error.message = 'Unauthorized';
          break;
        case 403:
          error.message = 'Forbidden';
          break;
        case 404:
          error.message = 'API endpoint not found';
          break;
        case 500:
          error.message = 'Server error';
          break;
        default:
          error.message = data?.message || `HTTP ${status} error`;
      }
    }

    return Promise.reject(error);
  }
);

// API方法
export const apiService = {
  // 获取用户信息
  getUserInfo: (userId) => {
    return new Promise((resolve, reject) => {
      api.post('/getUserInfo', { userId })
        .then(response => {
          if (response?.data?.code === 200) {
            resolve(response?.data.data)
          } else {
            reject(response?.data)
          }
        })
        .catch(err => {
          reject(err)
        })
    });
  },

  // 发送验证码
  sendVerificationCode: (userId) => {
    return new Promise((resolve, reject) => {
      api.post('/sendVerificationCode', { userId })
        .then(response => {
          if (response?.data?.code === 200) {
            resolve(true)
          } else {
            reject(response?.data)
          }
        })
        .catch(err => {
          reject(err)
        })
    });
  },

  // 注销账户
  deleteAccount: (userId, securityCode) => {
    return new Promise((resolve, reject) => {
      api.post('/deleteAccount', { userId, securityCode })
        .then(response => {
          if (response?.data?.code === 200) {
            resolve(true)
          } else {
            reject(response?.data)
          }
        })
        .catch(err => {
          reject(err)
        })
    });
  },

  // 网络连接测试
  testConnection: () => {
    return api.post('/getUserInfo', { userId: '123' });
  }
};

export default api;
